import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-layer-config-item',
  templateUrl: './layer-config-item.component.html',
  styleUrls: ['./layer-config-item.component.scss'],
  standalone: false,
})
export class LayerConfigItemComponent {
  @Input() isSelected: boolean | undefined
  @Input() key: string | undefined
  @Input() description: string | undefined
  @Input() icon: string | undefined

  @Output() clicked = new EventEmitter<string>()

  public getIcon(): string {
    if (this.icon) {
      return `rb-ic rb-ic-${this.icon}`
    }
    return ''
  }
}
